
import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { convertHM } from '../utils/timeCalculation';

export default function ReportTable(props) {
  // eslint-disable-next-line react/prop-types
  const { tableTitle, data, dataColumn } = props;

  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 50 }} aria-label="simple table">
          <TableHead>
            <TableRow style={{ width: '100%' }}>
              <TableCell style={{ padding: '5px' }}>{tableTitle}</TableCell>
              <TableCell style={{ padding: '5px', textAlign: 'center' }}>Duration</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((row, i) => (
              <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                <TableCell style={{ padding: '5px' }}>{row?.[dataColumn]}</TableCell>
                <TableCell style={{ padding: '5px', textAlign: 'center' }}>{convertHM(row?.total_time)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
